import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import Gruppo from "../../../interfaces/gruppo";
import { useState } from "react";
import createGruppi from "../../../api/gruppi/createGruppi";
import updateGruppo from "../../../api/gruppi/updateGruppo";
import { BluAlert, BluLoader } from "@bludata/components";

interface Props {
  onClose: () => void;
  gruppo: Gruppo;
  isEdit?: boolean;
}

function DialogModificaGruppo(props: Props) {
  const { onClose, gruppo, isEdit = false } = props;
  const [codiceGruppo, setCodiceGruppo] = useState(gruppo.codiceGruppo);
  const [descrizione, setDescrizione] = useState(gruppo.descrizione);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSaveClick = () => {
    if (!codiceGruppo || !descrizione) {
      setError("I campi Codice Gruppo e Descrizione sono obbligatori.");
      return;
    }

    const updatedGruppo = {
      ...gruppo,
      codiceGruppo,
      descrizione,
    };

    setLoading(true);

    // If editing existing group, use updateGruppo, otherwise createGruppi
    const savePromise = isEdit
      ? updateGruppo(gruppo.id!, updatedGruppo)
      : createGruppi({ ...updatedGruppo, id: undefined });

    savePromise
      .then(() => {
        onClose();
      })
      .catch((e) => {
        setError(
          e ||
            `Si è verificato un errore durante la ${
              isEdit ? "modifica" : "creazione"
            } del gruppo.`
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Dialog open fullWidth maxWidth="sm">
      <DialogTitle>
        {isEdit ? "Modifica gruppo" : "Crea un nuovo gruppo"}
      </DialogTitle>
      <DialogContent>
        <BluLoader open={loading} />
        <BluAlert
          show={!!error}
          handleClose={() => {
            setError("");
          }}
          text={error}
          type="error"
        />
        <Stack flexDirection="column" spacing={1} sx={{ mt: 1 }}>
          <TextField
            label="Codice Gruppo"
            value={codiceGruppo}
            onChange={(e) => setCodiceGruppo(e.target.value)}
          />
          <TextField
            label="Descrizione"
            value={descrizione}
            onChange={(e) => setDescrizione(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Annulla
        </Button>
        <Button variant="contained" onClick={onSaveClick}>
          Salva
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogModificaGruppo;
